module.exports = __webpack_public_path__ + "static/1-52277f17e2aa4da599f3255913ffbc16.png";